export default function () {
  return {
    company: {},
    payments: [],
    url: '',
    price: 0,
    loading: false,
  }
}
